export default function initExpandCollapse() {

  var addClickHandlersToProgramButtons = function(buttonsSelector, ancestorClass) {
    const collapsedListBtns = document.querySelectorAll('.collapsed-list-btn');

      collapsedListBtns.forEach(function(collapsedListBtn) {
        collapsedListBtn.addEventListener('click', function() {
          const collapsedListItem = this.closest('.collapsed-list-item');
          if (this.getAttribute('aria-expanded') === 'true') {
            collapsedListItem.classList.add('bg-color-secondary');
            collapsedListItem.classList.add('collapsed-list-open');
            this.setAttribute('aria-expanded', 'true');
          } else {
            collapsedListItem.classList.remove('bg-color-secondary');
            collapsedListItem.classList.remove('collapsed-list-open');
            this.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }

  addClickHandlersToProgramButtons('.collapsed-list-btn', 'collapsed-list-item');

}
